var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 0C1.194 0 0 1.194 0 2.66667V14.6667C0 16.1393 1.194 17.3333 2.66667 17.3333H21.3333C22.806 17.3333 24 16.1393 24 14.6667V2.66667C24 2.66667 24 0 21.3333 0H2.66667Z",
    fill: "#FFAC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.33301H24V6.66634H0V3.33301Z",
    fill: "#292F33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 9.33301H21.3337V13.333H2.66699V9.33301Z",
    fill: "#F4F7F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6662 12.6667C11.5308 12.6667 11.1055 11.86 11.0202 11.466C10.6555 11.4933 10.3002 11.668 9.81684 11.9753C9.30684 12.2993 8.72884 12.6667 7.9995 12.6667C7.2015 12.6667 6.71684 12.2167 6.66617 11.3333C6.66417 11.296 6.6915 11.208 6.68017 11.208C5.4415 11.208 4.5455 12.382 4.53684 12.394C4.40684 12.572 4.20417 12.6667 3.9995 12.6667C3.86217 12.6667 3.72417 12.6247 3.6055 12.5373C3.30884 12.3193 3.24417 11.902 3.46217 11.6053C3.5135 11.5353 4.7395 10 6.66617 10C7.9575 10 8.0315 10.9167 8.0515 11.2587L8.05617 11.3313C8.38017 11.3087 8.71684 11.0953 9.10284 10.8493C9.7435 10.4427 10.5382 9.93533 11.6028 10.208C12.1835 10.3567 12.2742 10.8953 12.3088 11.0987C12.3175 11.1493 12.3302 11.2253 12.3415 11.2493C12.3462 11.2493 12.4388 11.31 12.7262 11.336C13.2728 11.386 13.8735 11.15 14.5095 10.9007C15.1682 10.642 15.8495 10.3753 16.5835 10.3753C18.8428 10.3753 19.7615 11.4653 19.8588 11.5893C20.0855 11.8793 20.0348 12.298 19.7448 12.5247C19.6282 12.616 19.4908 12.6627 19.3535 12.6667C19.1488 12.6727 18.9448 12.5847 18.8088 12.4107C18.7928 12.3927 18.1888 11.708 16.5842 11.708C16.1022 11.708 15.5655 11.918 14.9968 12.1407C14.3242 12.4047 13.3742 12.6667 12.6662 12.6667V12.6667Z",
    fill: "#8899A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.8ec39658df4a090cbf9d287bce6a177d.svg";
export { ForwardRef as ReactComponent };